import Introduction7Container from './introduction7'

export default Introduction7Container